import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Progressbar } from "../Progressbar/Progressbar";
import "./Onboarding-5.css";
import { useOnboarding } from "../contexts/OnboardingContext";
import api from "../../../axiosconfig.js";
import { toast } from "react-toastify";

export const Onboarding5 = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(4);
  const totalSteps = 4;
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { onboardingData, setOnboardingData } = useOnboarding();
  const authUser = useSelector((state) => state.auth.user);

  // Function to submit final onboarding data and go to the next page
  const goToNextPage = async () => {
    if (isSubmitting) return;

    if (!name.trim()) {
      toast.warn("Please enter your name or click Skip.");
      return;
    }

    const { age, gender, focus } = onboardingData;
    const email = (
      onboardingData.email ||
      authUser?.email ||
      authUser?.sub ||
      ""
    )
      .trim()
      .toLowerCase();

    // Validation: Ensure all required fields are filled before proceeding
    if (!age || !gender || !focus) {
      toast.warn("Please complete all required fields before continuing.");
      return;
    }

    if (!email) {
      toast.error(
        "User email could not be determined. Please sign in to complete onboarding."
      );
      navigate("/login");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post("/register", {
        request: "profileData",
        email,
        name: name.trim(),
        age,
        gender,
        focus,
      });

      if (response.data?.result) {
        setOnboardingData((prev) => ({ ...prev, name: name.trim() }));
        navigate("/Onboarding-Header4", { state: { userName: name.trim() } });
      } else {
        console.error("Failed to save data");
        toast.error("Failed to save onboarding data. Please try again.");
      }
    } catch (err) {
      console.error("Error sending data", err);
      toast.error("There was an error submitting your data.");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to handle the "Skip" button logic
  const handleSkip = async () => {
    if (isSubmitting) return;

    const email = (
      onboardingData.email ||
      authUser?.email ||
      authUser?.sub ||
      ""
    )
      .trim()
      .toLowerCase();

    if (!email) {
      navigate("/login");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await api.post("/register", {
        request: "profileData",
        email,
        name: " ",
        age: null,
        gender: null,
        focus: null,
      });

      if (response.data?.result) {
        navigate("/Onboarding-Header4", { state: { userName: "Friend" } });
      } else {
        console.error("Failed to save data after skip");
        toast.error("Failed to save data. Please try again.");
      }
    } catch (err) {
      console.error("Error sending data after skip", err);
      toast.error("There was an error submitting your data after skip.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="onboarding5-page-wrapper">
      {/* Top Navigation / Glassmorphic Back button */}
      <button
        type="button"
        className="onboarding5-back-btn"
        onClick={() => navigate(-1)}
        aria-label="Go Back"
      >
        <span className="onboarding5-back-arrow" aria-hidden="true">
          &larr;
        </span>
        <span className="onboarding5-back-label">Back</span>
      </button>

      {/* Main Content Container (Centered horizontally & vertically) */}
      <div className="onboarding5-main-card">
        {/* Progress Bar Container */}
        <div className="onboarding5-progress-wrapper">
          <Progressbar step={step} totalSteps={totalSteps} />
        </div>

        {/* Title Header */}
        <div className="onboarding5-heading-group">
          <h1 className="onboarding5-page-title">What Should We Call You?</h1>
          <p className="onboarding5-page-subtitle">
            Let’s make this relationship personal.
          </p>
        </div>

        {/* Name Input Group */}
        <div className="onboarding5-input-container">
          <input
            type="text"
            placeholder="Type your name here"
            className="onboarding5-text-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                goToNextPage();
              }
            }}
            autoFocus
          />
        </div>

        {/* Action Buttons */}
        <div className="onboarding5-actions-group">
          <button
            type="button"
            className="onboarding5-continue-btn"
            onClick={goToNextPage}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Saving..." : "Continue"}
          </button>
          <button
            type="button"
            className="onboarding5-skip-btn"
            onClick={handleSkip}
            disabled={isSubmitting}
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboarding5;
